import { Box, Paper, Typography, Button, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import ToolTip from '../../../../components/ToolTip/ToolTip';
import IconPaper from './IconPaper';

const profileImg =
  'https://images.rawpixel.com/image_800/cHJpdmF0ZS9sci9pbWFnZXMvd2Vic2l0ZS8yMDI1LTA2L3Jhd3BpeGVsb2ZmaWNlN19waG90b19vZl95b3VuZ19pbmRpYW5fYm95X2hvbGRpbmdfc3R1ZGVudF9iYWNrcF9mMTgzNzMwYy00ZDdmLTRlNzUtOGE1MC1iZmFkNTI5MjMyYjFfMS5qcGc.jpg'; // Adjust path if needed

export default function ProfileCard({ leadDetails }) {
  return (
    <Box
      sx={{
        width: 320,
        height: 400,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // p: 2,
      }}
    >
      <Paper
        elevation={12}
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
          borderRadius: 3,
          overflow: 'hidden',
          border: '4px solid rgba(255,255,255,0.6)',
          backgroundColor: 'transparent',
        }}
      >
        {/* Background image */}
        <Box
          component="img"
          src={profileImg}
          alt="profile"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
          }}
        />

        {/* Soft bottom blur panel */}
        <Box
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            p: 3,
            background:
              'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(250,250,250,0.75) 40%, rgba(245,245,245,0.9) 100%)',
            backdropFilter: 'blur(6px)',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {leadDetails?.name || 'Not Available..!'}
            <Icon
              icon="ic:round-verified"
              width={18}
              height={18}
              style={{ marginLeft: 8, verticalAlign: 'middle', color: '#3b82f6' }}
            />
          </Typography>

          <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
            {leadDetails?.place || 'Not Available'}
          </Typography>

          {/* Bottom action row */}
          {/* <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2 }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.2,
                py: 0.6,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.8)',
                boxShadow: 1,
              }}
            >
              <Icon icon="ic:round-people" width={18} height={18} />
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                312
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.75,
                px: 1.2,
                py: 0.6,
                borderRadius: 2,
                background: 'rgba(255,255,255,0.8)',
                boxShadow: 1,
              }}
            >
              <Icon icon="ic:round-check-circle" width={18} height={18} />
              <Typography variant="caption" sx={{ fontWeight: 600 }}>
                48
              </Typography>
            </Box>

            <Box sx={{ flex: 1 }} />

            <Button
              variant="contained"
              size="small"
              sx={{
                borderRadius: 6,
                textTransform: 'none',
                boxShadow: 3,
              }}
              startIcon={<Icon icon="ic:round-person-add" />}
            >
              Follow +
            </Button>
          </Stack> */}
          {/* ---------------------------------------------------------- */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              // padding: 2,
            }}
          >
            <Stack direction={'row'} spacing={2}>
              <ToolTip
                action={() => {
                  if (leadDetails) {
                    window.open(`https://wa.me/${leadDetails.contactNo}`, '_blank');
                  }
                }}
                content={
                  <IconPaper>
                    <Icon icon="ic:baseline-whatsapp" height={23} width={23} />
                  </IconPaper>
                }
                expand={leadDetails ? leadDetails.contactNo : 'Not Available..!'}
              />

              <ToolTip
                content={
                  <IconPaper>
                    <Icon icon="ic:outline-alternate-email" height={23} width={23} />
                  </IconPaper>
                }
                expand={leadDetails?.email || 'Not Available..!'}
              />
              <ToolTip
                content={
                  <IconPaper>
                    <Icon icon="material-symbols:school-outline" height={23} width={23} />
                  </IconPaper>
                }
                expand={leadDetails?.schoolName || 'Not Available..!'}
              />
            </Stack>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
